module.exports = __webpack_public_path__ + "static/media/Cavalier075_4c.c9eb0f11.svg";